export default "__VITE_ASSET__DxA2lAD9__"